<template>
    <div>
      <h2 class="text-1xl font-bold text-gray-700">
        Configuración comprobantes
      </h2>
      <MainVouchers />
    </div>
  </template>
  
  <script>
  import MainVouchers from "@/components/ConfigurationModules/Vouchers/MainVouchers.vue";
import { useRoute } from 'vue-router';
import { onBeforeMount, onMounted } from 'vue';
import { findSubmoduleIdByDescription } from '@/hisAcces';
  export default {
    name: "MainVoucher",
    components: {
        MainVouchers,
    },
  setup() {
    const route = useRoute();
    onBeforeMount(() => {
      if (!findSubmoduleIdByDescription(route.path)) {
        window.location.href = "/login";
      }
    });

    onMounted(() => {
      document.title =
        route.meta.title + process.env.VUE_APP_TITLE ||
        process.env.VUE_APP_TITLE;
    });
  },
  };
  </script>
  